import { render, staticRenderFns } from "./zl.vue?vue&type=template&id=ab0edcb4&scoped=true"
import script from "./zl.vue?vue&type=script&lang=js"
export * from "./zl.vue?vue&type=script&lang=js"
import style0 from "./zl.vue?vue&type=style&index=0&id=ab0edcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0edcb4",
  null
  
)

export default component.exports